<template>
  <div>
    sjflsjfls
  </div>
</template>

<script>
import customProtocolCheck from "custom-protocol-check";
import { getDwgTicket } from '@/api/view/hip/common/common.js'

export default {
  name: "DwgViewer",

  data() {
    return {
      key : '',
      shipNo : '',
      docNum : '',
      revNum : '',
      userId : '',
    }
  },

  async mounted() {
    this.key = this.$route.query.key
    this.shipNo = this.$route.query.Ship_Num
    this.docNum = this.$route.query.Doc_Num
    this.revNum = this.$route.query.Rev_Num
    this.userId = this.$route.query.UserID;

    if(this.key === null || this.key === '' || this.key === undefined)
      this.key = 'key'

    const param = {
      shipNum: this.shipNo,
      docNum: this.docNum,
      revNum: this.revNum,
      //userId: this.$store.state.user.makerCd,
      userId: this.userId,

      workCode : 'DWG',
      webKey : this.key,
    }

    // 뷰어 호출
    getDwgTicket(param).then(res => {
      let ticket = res.body;

      if(ticket === undefined){
        alert('key error');
        return;
      }


      customProtocolCheck(
          // Custom Protocol
          ('npshmdsecuview://' + ticket),
          // Custom Protocol 이 지원하지 않을 경우
          function() {
            //location.href = "http://s-viewer.hmd.co.kr/Setup/Launcher/eng/NpsLauncherSetup.msi";
            //location.href = "http://ibiz.hvs.com.vn/sview/Setup/Launcher/eng/NpsLauncherSetup.msi";
            location.href = "https://ibiz.hd-hvs.com/sview/Setup/Launcher/eng/NpsLauncherSetup.msi";
          },
          // Custom Protocol 이 지원할 경우
          function() {
            console.log("supported");
          }
      );
    }).finally(() => {


    })
    //http://localhost:8080/#/DwgViewer?Ship_Num=834806&Doc_Num=WB11BJ102&Rev_Num=000&UserID=A503264&key=3472088854
    //http://dwg.hmd.co.kr/pdfviewer/MIS_DocSearch_Hvs.asp?Ship_Num=123456&=" + TRIM(ls_dwg_no)+"&="+TRIM(ls_rev_no) + "&=" + Trim(gs_user_id)
  },
  created(){
    self.close();
  }
}
</script>

<style scoped>

</style>